import { render, staticRenderFns } from "./triplet_pause.vue?vue&type=template&id=49beddeb&scoped=true"
import script from "./triplet_pause.vue?vue&type=script&lang=js"
export * from "./triplet_pause.vue?vue&type=script&lang=js"
import style0 from "./triplet_pause.vue?vue&type=style&index=0&id=49beddeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49beddeb",
  null
  
)

export default component.exports